import PAProductCodeUtil from 'conditional?if=endorsement-products&equals=PersonalAuto!edge/endorsement/pa/PAProductCodeUtil';
import HOProductCodeUtil from 'conditional?if=endorsement-products&equals=Homeowners!edge/endorsement/ho/HOProductCodeUtil';

export default {
    getGenericProductCode: function getGenericProductCode(productCode) {
        var normalisedProductCode = productCode;
        if (PAProductCodeUtil) {
            normalisedProductCode = PAProductCodeUtil.normaliseProductCode(normalisedProductCode);
        }
        if (HOProductCodeUtil) {
            normalisedProductCode = HOProductCodeUtil.normaliseProductCode(normalisedProductCode);
        }
        return normalisedProductCode;
    },
    getLobKeyValue: function getLobKeyValue(key, productCode) {
        var normalisedKey = key;
        if (PAProductCodeUtil) {
            normalisedKey = PAProductCodeUtil.getLobSpecificKeyValue(key, productCode);
        }
        if (HOProductCodeUtil) {
            normalisedKey = HOProductCodeUtil.getLobSpecificKeyValue(key, productCode);
        }
        return normalisedKey;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/endorsement/GenericProductCodeUtil.js
// module id = 125
// module chunks = 0